import { render } from "./ClasElem.vue?vue&type=template&id=17d7e92e"
import script from "./ClasElem.vue?vue&type=script&lang=js"
export * from "./ClasElem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__